import Calendar from 'react-calendar';
import MyContext from '@/shared/contexts/AppContext';
import TabelaResumo from '@/modules/home/tabelaresumo';
import TabelaTotais from '@/modules/home/tabelatotais';
import { DataAmigavel } from '@/shared/utils/datas';
import { useContext, useState } from 'react';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

export default function HomeIndexFPage() {
  const [value, onChange] = useState<Value>(new Date());
  const [exibirtodos, setExibirTodos] = useState<boolean>(false);

  const context = useContext(MyContext);
  if (!context)
    throw new Error('DisplayComponent deve ser usado dentro de um MyProvider');

  return (
    <>
      <section
        className="d-flex align-items-center"
        style={{ padding: '20px' }}
      >
        <img
          src="./img/logo_dpe_2024_nome.png"
          alt="Defensoria Pública do Estado de Sergipe"
          className="float-left img-fluid mr-3"
          style={{ maxHeight: '100px' }}
        />
        <div className="text-center mx-auto">
          <h2>Corregedoria Geral</h2>
          <p id="descricao-ferias">
            Gestão de férias, abonos, faltas, licenças e afastamentos.
          </p>
        </div>
      </section>

      <div className="row">
        <div className="col-md-4">
          <div>
            <div className="card">
              <div className="card-header text-center">
                Resumo: {DataAmigavel(value as Date)}
              </div>
              <div className="card-body">
                <TabelaTotais dia={value as Date} />
              </div>
              <div className="card-footer text-muted text-center">
                Defensoria Pública do Estado de Sergipe
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="card">
              <div className="card-body d-flex text-center align-items-center justify-content-center">
                <Calendar onChange={onChange} value={value} />
              </div>
              <div className="card-footer text-muted text-center">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="exibirtodos"
                    onChange={(e) => {
                      setExibirTodos(e.target.checked);
                    }}
                  />
                  <label className="form-check-label" htmlFor="exibirtodos">
                    Desmarque para exibir todos os defensores.
                  </label>
                </div>

                {/* <label htmlFor='exibirtodos'>Exibir todos
                                    <input title="Marque para exibir todos." id='exibirtodos' type="checkbox" checked={exibirtodos} onChange={(e) => { setExibirTodos(e.target.checked) }} />
                                    <span className="checkmark"></span>
                                </label> */}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-8">
          <div className="card">
            <div className="card-header text-center">
              Situação dos Defensores no Dia: {DataAmigavel(value as Date)}
            </div>
            <div className="card-body">
              <TabelaResumo dia={value as Date} naovazio={exibirtodos} />
            </div>
            <div className="card-footer text-muted text-center">
              Defensoria Pública do Estado de Sergipe
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
